/* eslint-disable max-len */
import { useContext } from 'react';
import { ControlledDateTimePickerDatatestid } from '../../../constants/index.js';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { CalendarBody } from './CalendarBody.js';
import { CalendarContext } from './CalendarContext.js';
import { CalendarFooter } from './CalendarFooter.js';
import { CalendarHead } from './CalendarHead.js';
import { StyledCalendarWrapper, StyledShadowWrapper } from './Styleds.js';

// ({ className = '' }: { className?: string })
// <StyledShadowWrapper className={className}>
// is required for styled-components, without this we can't styled(CalendarContent)...
// https://stackoverflow.com/questions/52542817/styled-components-not-applying-style-to-custom-functional-react-component
export const CalendarContent = ({ className = '' }: { className?: string }): JSX.Element => {
  const {
    getProps,
    props: { readOnly, applyAriaDisabled },
  } = useContext(ControlledDateTimePickerContext);
  const { daysMatrixByWeekday } = useContext(CalendarContext);

  return (
    <StyledShadowWrapper
      className={className}
      data-testid={ControlledDateTimePickerDatatestid.CONTROLLER_COMPONENT.CALENDAR}
      getOwnerProps={getProps}
    >
      <StyledCalendarWrapper $readOnlyStyles={readOnly || applyAriaDisabled}>
        <CalendarHead />
        <CalendarBody weekRowsNum={daysMatrixByWeekday.length} />
        <CalendarFooter />
      </StyledCalendarWrapper>
    </StyledShadowWrapper>
  );
};
